import React from 'react';
import { ResultTreeFixture } from './ResultTreeFixture';
import { ToggleSportProps } from '../TreeSport';
import { FlatTree, Level } from '../../../models/api/codegen/code';
import { TreeCategory } from '../TreeCategory';
import { ResultTreeSport } from './ResultTreeSport';
import { RowComponentProps } from 'react-window';

export type RowProps = {
    visibleLevels: Level[];
    tree: FlatTree;
    toggleSport: ToggleSportProps['toggleSport'];
};

export function ResultTreeRow({ index, visibleLevels, tree, toggleSport, style }: RowComponentProps<RowProps>) {
    const level = visibleLevels[index];

    const render = () => {
        switch (level.l) {
            case 'SPORT':
                return (<ResultTreeSport id={level.i} tree={tree} toggleSport={toggleSport} />);
            case 'CATEGORY':
                return <TreeCategory id={level.i} tree={tree} />;
            case 'FIXTURE':
                return <ResultTreeFixture id={level.i} tree={tree} />;
            default:
                return <></>;
        }
    };

    return <div style={style}>{render()}</div>;
}
